import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AuthoredEvidence,
  FormLocalDateField,
  FormPanel,
  FormTextField,
} from '@eas/common-web';

export function Fields() {
  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__HOLIDAY__DETAIL__PANEL__GENERAL"
            defaultMessage="Všeobecné"
          />
        }
      >
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="ZSD__HOLIDAY__DETAIL__FIELD_LABEL__NAME"
              defaultMessage="Názov"
            />
          }
          required={true}
        />
        <FormLocalDateField
          name="day"
          label={
            <FormattedMessage
              id="ZSD__HOLIDAY__DETAIL__FIELD_LABEL__DAY"
              defaultMessage="Deň"
            />
          }
          required={true}
        />
        <AuthoredEvidence.AuthoredFields />
      </FormPanel>
    </>
  );
}
